
/**
 * @param {*} param0 context for render function interpolation
 * @returns {JSX.Element} react component
 */
export const desThumbnailRenderFunction = ( props ) => {
    const { vmo, viewModel } = props;
    if( !vmo ) {
        return null;
    }
    const thumbnailUrl = viewModel.data.url ? viewModel.data.url : vmo.typeIconURL;
    return (
        <img className='aw-base-icon aw-type-icon' src={thumbnailUrl} alt={vmo.modelType && vmo.modelType.displayName ? vmo.modelType.displayName : ''} />
    );
};
